/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpHeaders, HttpParams } from "@angular/common/http";

export interface ApiRequestOptionsHttp {
	headers?: HttpHeaders;
	params?: HttpParams;
	body?: any;
	observe: "response";
}
